export { default, default as Toggle } from './Toggle'
export { default as toggleTheme } from './themes/Toggle.theme'
export * as ToggleStyles from './styles/Toggle.style'

export type { ToggleProps } from './Toggle.types'
export type { AppearanceKeys, ToggleTheme } from './themes/Toggle.theme.types'
export type { StyledToggleProps } from './styles/Toggle.style.types'
